import type { NextPage } from 'next';
import { signOut, useSession } from 'next-auth/react';

import { Button, Container } from '@dansk-metal/ui';

import TemplateLayout from '@web/layouts/template/template';

import { LoginButton } from '@apps/web/src/components/login-button/login-button';
import { UmbracoPage } from '@apps/web/src/services/umbraco/types/documents/UmbracoDocument';

import styles from './login.module.scss';

export const contentAlias = 'loginPage';

export type LoginPageData = UmbracoPage<typeof contentAlias, {
	umbracoUrlName?: string;
	headline: string;
}>;

const LoginTemplate: NextPage<{ pageData: LoginPageData }> = ({ pageData }) => {
	const { status } = useSession();

	return (
		<TemplateLayout>
			<Container className={styles.container}>
				<h1>{pageData.properties.headline}</h1>
				{status !== 'authenticated' && (
					<LoginButton />
				)}

				{status === 'authenticated' && (
					<Button onClick={() => signOut()}>Logout</Button>
				)}
			</Container>
		</TemplateLayout>
	);
};

export default LoginTemplate;
